@for (val of currentConfig.details; track val) {
  <ng-template #details>
    <div>{{val.flagValue}}</div>
  </ng-template>
  @if (config.setting.type == undefined && currentConfig.showFlag!=undefined && currentConfig.showFlag && !config.hasOwnProperty('flag_only')) {
    <span
      class="grid-high-icon" [popover]="details" placement="top" container="body" triggers="mouseenter:mouseleave"
      #pop="bs-popover">
    </span>
  }
  @if (config.setting.type == undefined && currentConfig.showFlag!=undefined && currentConfig.showFlag && config.hasOwnProperty('flag_only')) {
    <span
      [ngClass]="val.class || ((currentConfig['data']) | getClass: config.setting.conditions)" [ngStyle]="val.color ? {'--flag-color': val.color} : {}">
    </span>
  }
  @if (config.setting.type && config.setting.type == 'image' && currentConfig.showFlag!=undefined && currentConfig.showFlag && !config.hasOwnProperty('flag_only')) {
    <span
      [popover]="details" placement="top" container="body" triggers="mouseenter:mouseleave"
      #pop="bs-popover">
      <img class="image-popover" src="{{val.img}}">
    </span>
  }
}
@if (config.hasOwnProperty('flag_only') && isNonFormulary) {
  <span class="grid-non-formulary" title="Non Formulary Item"></span>
}
